import Box from "@mui/material/Box";
import FormGroup from "@mui/material/FormGroup";
import Typography from "@mui/material/Typography";
import { useTheme } from "@mui/material/styles";
import {
  GREY_COLOR,
  INPUT_COLOR_BORDER,
  WHITE_DARK_COLOR,
} from "../../../utils/colors";

const CheckGroup = ({
  options = [],
  selectedValues = [],
  onChange,
  name = "checkbox_group",
  readOnly,
}) => {
  const theme = useTheme();
  const selected = Array.isArray(selectedValues) ? selectedValues : [];
  const interactive = !readOnly;

  const toggle = (value) => {
    if (!interactive || typeof onChange !== "function") return;
    const isSelected = selected.includes(value);
    onChange(
      isSelected
        ? selected.filter((item) => item !== value)
        : [...selected, value]
    );
  };

  const rowSx = {
    display: "flex",
    alignItems: "flex-start",
    gap: 1.25,
    p: 1.5,
    borderRadius: "9px",
    backgroundColor: WHITE_DARK_COLOR,
    border: `1px solid ${INPUT_COLOR_BORDER}`,
    cursor: interactive ? "pointer" : "default",
    transition: "border-color 0.2s ease, background-color 0.2s ease",
    opacity: interactive ? 1 : 0.92,
    ...(interactive && {
      "&:hover": {
        backgroundColor: GREY_COLOR,
        borderColor: theme.palette.primary.main,
      },
    }),
  };

  const checkboxSx = {
    width: 16,
    height: 16,
    accentColor: theme.palette.primary.main,
    cursor: "inherit",
    flexShrink: 0,
    marginTop: "2px",
  };

  return (
    <FormGroup
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: 1,
      }}
    >
      {options.map((option) => {
        const inputId = `${name}-${option.value}`;
        const isChecked = selected.includes(option.value);

        return (
          <Box
            key={option.value}
            component="label"
            htmlFor={inputId}
            sx={rowSx}
          >
            <Box
              component="input"
              type="checkbox"
              id={inputId}
              name={name}
              value={option.value}
              checked={isChecked}
              disabled={!interactive}
              onChange={() => toggle(option.value)}
              sx={checkboxSx}
            />

            <Typography
              sx={{
                color: "text.primary",
                fontSize: "14px",
                lineHeight: 1.4,
                cursor: "inherit",
              }}
            >
              {option.label}
            </Typography>
          </Box>
        );
      })}
    </FormGroup>
  );
};

export default CheckGroup;
